import React from "react";
import { Link } from "react-router-dom";

function Contact() {
	return (
		<div id='Contact' className='py-40 bg-transparent sm:py-40'>
			<div className='mx-auto max-w-7xl px-4 lg:px-16'>
				<div className='text-center max-w-2xl mx-auto'>
					<h1 className='text-3xl font-bold tracking-tight leading-10 text-gray-900 sm:text-6xl'>
						Keep in touch with me <br />
						<span className='block mt-4 leading-10'>Say Hi!</span>
					</h1>
				</div>

				<div className='mt-16 flex justify-center gap-x-6 '>
					<Link
						to={"https://wa.me/+2348167976085"}
						target='_blank'
						className='bg-gray-900 px-7 py-4 text-sm font-bold tracking-wide text-white shadow-sm hover:bg-transparent hover:border-gray-900 hover:text-gray-900 border-2 border-gray-900 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600'>
						START A CONVERSATION
					</Link>
				</div>
			</div>
		</div>
	);
}

export default Contact;
